/* eslint-disable import/no-named-default */
import { default as useArraySlice } from './useArraySlice';
import { default as useInView } from './useIntersection';
import { default as useUserFavorites } from './useUserFavorites';
import { default as useUserAllFavoriteBoats } from './useUserAllFavoriteBoats';
import { default as useRemoveFavoriteBoat } from './useRemoveFavoriteBoat';
import { default as useAddToFavoriteBoat } from './useAddToFavoriteBoat';

export {
  useArraySlice,
  useInView,
  useUserFavorites,
  useUserAllFavoriteBoats,
  useRemoveFavoriteBoat,
  useAddToFavoriteBoat,
};
